import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CustomerAuthApiModel } from 'app/models/customer.model';
import { CustomersAdminService } from 'app/services/customer/customers-admin.service';


@Component({
  selector: 'app-customers-auth-form',
  templateUrl: 'customersAuthForm.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})

export class CustomersAuthFormComponent implements OnInit {
  @Input() data: any;
  @Input() companyCode: string;
  @Output() esito = new EventEmitter<any>();
  form: FormGroup;
  invalidSubmit: boolean;
  public tempPassword = '';

  constructor(
    private svcCustomersAdmin: CustomersAdminService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.tempPassword = this.generateRandomPassword();
    this.form = this.fb.group({
      'password': new FormControl(this.tempPassword)
  });
  }

  generateRandomPassword() {
    let length = 10,
      charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!?$%&',
      pwd = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      pwd += charset.charAt(Math.floor(Math.random() * n));
    }
    return pwd;
  }

  save(): void {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    this.tempPassword = this.form.get('password').value;
    this.resetPassword();
  }

  resetPassword() {

    const datiCliente = new CustomerAuthApiModel();
    datiCliente.userAccount = this.data.user_account;
    datiCliente.accountType = this.data.account_type_host_id;
    datiCliente.sourceCode = this.data.source_system_host_id;
    datiCliente.companyCode = this.companyCode;
    datiCliente.notifyUser = false;

    this.svcCustomersAdmin.generateSecurityCodeForPasswordReset(datiCliente).subscribe( res => {
      const token = res.token;
      const dati = {
        'companyCode': datiCliente.companyCode,
        'accountType': datiCliente.accountType,
        'sourceCode': datiCliente.sourceCode,
        'userAccount': datiCliente.userAccount,
        'securityCode': token,
        'userPassword': this.tempPassword
      }
      this.svcCustomersAdmin.resetPasswordWithSecurityCode(dati).subscribe( res2 => {
        this.esito.emit(res2);
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/admin/customersAuthForm.component.ts